import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFossilEnergyGasCan = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "fossil-energy-gas-can" }),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 7.5,
			y1: 11.25,
			x2: 15,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 15,
			y1: 11.25,
			x2: 7.5,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M19.5,21A1.5,1.5,0,0,1,18,22.5H4.5A1.5,1.5,0,0,1,3,21V6A1.5,1.5,0,0,1,4.5,4.5h9.75L19.5,9.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M4.5,4.5V3A1.5,1.5,0,0,1,6,1.5h4.5A1.5,1.5,0,0,1,12,3V4.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15,5.25l1.189-1.189a1.5,1.5,0,0,1,2.122,0l1.628,1.628a1.5,1.5,0,0,1,0,2.122L18.75,9"
		})
	]
});
export default SvgFossilEnergyGasCan;
